import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'app-treaty-country-pair-selector-dialog',
  templateUrl: './treaty-country-pair-selector-dialog.component.html',
  styleUrls: ['./treaty-country-pair-selector-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TreatyCountryPairSelectorDialogComponent implements OnInit, IDialogView {

  data: DialogModel;
  selectedCountry: any;
  selectedCountryTwo: any;
  constructor() { }

  ngOnInit(): void {
    this.selectedCountry = this.data?.input?.selectedCountry;
    this.selectedCountryTwo = this.data?.input?.selectedCountryTwo;
    this.setIsDisabledOkButton();
  }

  onCancelClicked(): any {
  }

  onClosedClicked(): any {
  }

  onOkClicked(): any {
    this.data.input.selectedCountry = this.selectedCountry;
    this.data.input.selectedCountryTwo = this.selectedCountryTwo;
    return true;
  }

  setIsDisabledOkButton() {
    this.data.isDisabledOkButton = !(this.selectedCountry && this.selectedCountryTwo);
  }

  onOptionalButtonClicked(): boolean {
    return false;
  }

  onOtherButtonClicked(): boolean {
    return false;
  }

  onCountryChange(countryInfo) {
    this.selectedCountry = countryInfo.countryOne;
    this.selectedCountryTwo = countryInfo.countryTwo;
    this.setIsDisabledOkButton();
  }
  onCountryTwoChange(countryInfo) {
    this.selectedCountry = countryInfo.countryOne;
    this.selectedCountryTwo = countryInfo.countryTwo;
    this.setIsDisabledOkButton();
  }

}
